import { Environment } from '@/enums/environment';

const ENVIRONMENT_HOSTNAMES: Record<Environment, string> = {
    [Environment.LOCAL]: 'localhost',
    [Environment.DEV]: 'dev.onboarding.gls-group.com',
    [Environment.STAGE]: 'stage.onboarding.gls-group.com',
    [Environment.MT1]: 'mt1.onboarding.gls-group.com',
    [Environment.PROD]: 'onboarding.gls-group.com'
};

export { ENVIRONMENT_HOSTNAMES };
